import { instance as axios } from "../../configs/axios";

export default {
  activeStores: () => axios.get(`/Store/GetStores`),
  load: (options = { params: [] }) => axios.post(`/Store/Load`, options),
  loadWithMargin: (options = { params: [], marginType: null }) => axios.post(`/Store/LoadWithMargin`, options),
};
